// Shared by the interactive sidebar and the flat export/PDF variant, so the
// printed report groups and names the rules exactly the way the dashboard does.

// Strip internal "FE_" prefix and "_FEBeta" suffix from Yara/CAV rule names
export const cleanRuleName = (name = "") =>
  String(name).replace(/^FE_/i, "").replace(/_FEBeta$/i, "");

export const prepareData = (rawData, engine) => {
  const filteredData = rawData?.filter((el) =>
    engine === "sigma" ? el.source === engine : el.engine === engine,
  );

  // Yara/CAV outputs come one entry per matched file; group them by rule name
  // so the sidebar lists each rule once with all of its matches attached.
  if (engine === "Yara" || engine === "CAV") {
    const ruleGroups = {};
    filteredData?.forEach((el) => {
      if (!ruleGroups[el.threat]) ruleGroups[el.threat] = [];
      ruleGroups[el.threat].push(el);
    });

    return Object.entries(ruleGroups).map(([ruleName, matches]) => ({
      ...matches[0],
      type: engine,
      id: ruleName,
      value: cleanRuleName(ruleName),
      matches,
    }));
  }

  const mappedData = filteredData?.map((el, idx) =>
    engine === "sigma"
      ? { ...el, type: engine, id: el.rule_name, value: el.rule_name }
      : { ...el, type: engine, id: `${idx}${el.threat}`, value: el.threat },
  );

  return mappedData || [];
};

// The severity buckets, in the order a report should read them.
export const SEVERITIES = ["High", "Medium", "Low"];

// The engines a bucket can hold. "sigma" is matched on `source`, the other two
// on `engine` — prepareData already handles that difference.
export const ENGINES = [
  { key: "sigma", label: "Sigma" },
  { key: "Yara", label: "Yara" },
  { key: "CAV", label: "CAV" },
];
